import React from "react";
import { Link } from "react-router";

import { Button } from "../Controls";
import "../../assets/styles/styles.less";
import "./styles.less";

import PledgeImage from "../../assets/images/2018/graphics/Pledge_10.png";
import MessageImage from "../../assets/images/2018/graphics/Send_Message.png";
import LoveImage from "../../assets/images/2018/graphics/Love.png";

import texts from "../../assets/strings/how";

const HowItWorksDesktop = () => (
  <div className="how desktop">
    <section className="intro">
      <h2>{texts.intro.h2}</h2>
      <p>{texts.intro.p}</p>
      <Link style={{ width: 250, marginBottom: 40 }} to="/proceed">
        <Button label={texts.buttonLabel} primary={true} large={true} />
      </Link>
    </section>
    <section className="how-it-works">
      <h1>{texts.how.h1}</h1>
      <div className="flex-row flex-center grid-100 area2 bordered">
        <div className="flex-column flex-center grid-50">
          <h2>{texts.how.step1Title}</h2>
          <p>{texts.how.step1}</p>
        </div>
        <div className="flex-column flex-center grid-50">
          <img style={{ maxWidth: "100%" }} src={PledgeImage} />
        </div>
      </div>
      <div className="flex-row flex-center grid-100 area2 bordered">
        <div className="flex-column flex-center grid-50">
          <img style={{ maxWidth: "100%" }} src={MessageImage} />
        </div>
        <div className="flex-column flex-center grid-50">
          <h2>{texts.how.step2Title}</h2>
          <p>{texts.how.step2}</p>
        </div>
      </div>
      <div className="flex-row flex-center grid-100 area2 bordered">
        <div className="flex-column flex-center grid-50">
          <h2>{texts.how.step3Title}</h2>
          <p>{texts.how.step3}</p>
        </div>
        <div className="flex-column flex-center grid-50">
          <img style={{ maxWidth: "100%" }} src={LoveImage} />
        </div>
      </div>
      <p className="success">{texts.success.h3}</p>
      <p
        className="note"
        dangerouslySetInnerHTML={{ __html: texts.bottom.note }}
      />
    </section>
    <section className="actions">
      <Link style={{ width: 250, marginBottom: 40 }} to="/proceed">
        <Button label={texts.buttonLabel} primary={true} large={true} />
      </Link>
    </section>
  </div>
);
export default HowItWorksDesktop;



// WEBPACK FOOTER //
// ./components/HowItWorks/HowItWorksDesktop.js